import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { FilterClickedEvent, withAnalytics } from '@atlassian/mpac-analytics';
import { List } from 'immutable';
import React, { Component } from 'react';
import { ANALYTICS_SUBJECT_ID_SIDEBAR_FACET_FILTER, ANALYTICS_SUBJECT_ID_TOPBAR_FACET_FILTER, EVENT_CHANNEL, EVENT_SOURCE } from '../../../../../constants/analytics/events';
import InternalFacetDropdown from './InternalFacetDropdown';
import { jsx as _jsx } from "react/jsx-runtime";
export class ConjunctiveFacetDropdown extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "onConjunctiveFacetRemoveClick", e => {
      const selectedItem = this.getSelectedItem();
      if (selectedItem) {
        const filterKey = selectedItem.facetKey;
        const filterValue = selectedItem.facetValue;
        const newFilters = this.props.filters.delete(filterKey);
        const label = selectedItem.selectedContent;
        this.props.fireAnalyticsEvent({
          eventType: FilterClickedEvent,
          actionSubjectId: this.props.facetBar === 'side' ? ANALYTICS_SUBJECT_ID_SIDEBAR_FACET_FILTER : ANALYTICS_SUBJECT_ID_TOPBAR_FACET_FILTER,
          source: this.props.perspective,
          label,
          attributes: {
            sourceComponent: EVENT_SOURCE,
            currentPerspective: this.props.perspective,
            filterKey,
            filterValue,
            selected: false
          }
        }, EVENT_CHANNEL);
        this.props.stateChangeRequested({
          filters: newFilters
        });
      }
      e.stopPropagation();
    });
  }
  getSelectedItem() {
    if (List.isList(this.props.items)) return this.props.items.find(i => i.selected);else {
      return Object.values(this.props.items)[0].merge(Object.values(this.props.items)[1]).find(item => item.selected);
    }
  }
  render() {
    const selectedItem = this.getSelectedItem();
    const noFilterSelectedItem = !selectedItem;
    const label = noFilterSelectedItem ? this.props.label : selectedItem.selectedContent || selectedItem.content;
    return /*#__PURE__*/_jsx(InternalFacetDropdown, {
      closeOnItemSelected: true,
      facetBar: this.props.facetBar,
      facetValue: this.props.label,
      filters: this.props.filters,
      hasSelectedItem: !noFilterSelectedItem,
      items: this.props.items,
      label: label,
      onItemActivated: this.props.onItemActivated,
      onRemoveClick: this.onConjunctiveFacetRemoveClick,
      perspective: this.props.perspective
    });
  }
}
export default withAnalytics(ConjunctiveFacetDropdown);